import React from 'react';
import PropTypes from 'prop-types';

import NestedFilterItem from 'components/upb_viewer/NestedFilterItem';

function NestedFiltersGroup({
  options,
  selectedOptions,
  setSelectedOptions,
  autoCollapseWhenInactive = false,
  showSubOptions = false,
  showCategoryBadges = false,
}) {
  return (
    <>
      {options?.map((option, index) => (
        <NestedFilterItem
          key={`${option.label}_${option.value}_${index}`}
          option={option}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          isRootNode
          autoCollapseWhenInactive={autoCollapseWhenInactive}
          showSubOptions={showSubOptions}
          showCategoryBadges={showCategoryBadges}
        />
      ))}
    </>
  );
}

NestedFiltersGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  selectedOptions: PropTypes.arrayOf(PropTypes.object),
  setSelectedOptions: PropTypes.func.isRequired,
  autoCollapseWhenInactive: PropTypes.bool,
  showSubOptions: PropTypes.bool,
  showCategoryBadges: PropTypes.bool,
};

export default NestedFiltersGroup;
